
import Vue from "vue";
import VueRouter from "vue-router";
import App from './App.vue'
import MainMenu from './components/MainMenu.vue'
import Contact from './components/Contact.vue'
import VideoMenu from './components/VideoMenu.vue'
import PhotoAlbum from './components/PhotoAlbum.vue'
import PhotoGallery from './components/PhotoGallery.vue'

Vue.use(VueRouter);

Vue.config.productionTip = true


const VideoDummy = {
	props: ['data'],
	template: "<div></div>"
}

const routes = [
{  path: '/', name: "home", component: MainMenu},
{  path: '/fotos/:gid', name: "fotos", component: PhotoAlbum},
{  path: '/fotos', name: "gallery", component: PhotoGallery},
{  path: '/kontakt', name: "kontakt", component: Contact},
{  path: '/videos', name: "videomenu", component: VideoMenu},
{  path: '/videos/:id', name: "video", component: VideoDummy},
]

const router = new VueRouter({
  routes,
  // base: process.env.NODE_ENV !== 'production'  ? '/'  : '/vue/',
  mode: 'history',
})

Vue.filter('nospace', function (value) {
			if (!value) return ''
			value = value.toString()
			return value.replace(/ /g,'')
})

new Vue({
  render: h => h(App),
  router,
  template: '<App/>',
	components: {
    App
	},
	data () {
    return {
        data: [],
    }
},
beforeCreate: function() {
    //document.body.className = Math.random()>0.5 ? 'bg1' : 'bg2'
},
computed: {
},
methods: {
  goto(where) {
    console.log("goto", where)
    if(where < 0 && history.state === null) {
      where = "home"
    }
    if(isNaN(where))
      router.push({name: where || "home"})
    else
      router.go(where)
  }
},
watch: {
},
async mounted() {
}
}).$mount('#app')
